import { useTheme as useEmotionTheme } from "@emotion/react";
import { Theme } from "../../themes/theme";

const useTheme = (): Theme => {
  const theme = useEmotionTheme() as Theme;
  return theme;
};

export default useTheme;
